import {PageType} from 'hsi/types/shared';

export default function mapPageTypesToOptions(pageTypes: PageType[]) {
    return pageTypes.map(({value, iconName}) => ({value, iconName, label: `pageTypes.${value}`}));
}
